/**
 * 数据脱敏工具函数
 */

/**
 * 脱敏姓名
 * @param {String} name - 姓名
 * @returns {String} 脱敏后的姓名
 * 
 * 规则：
 * - 3个字：中间字显示为星号（如：张*三）
 * - 2个字：最后一个字显示为星号（如：张*）
 * - 英文：不做处理
 */
export function maskName(name) {
  if (!name || typeof name !== 'string') {
    return name || ''
  }
  
  const trimmedName = name.trim()
  
  // 如果为空，直接返回
  if (!trimmedName) {
    return ''
  }
  
  // 判断是否为英文（包含英文字母）
  const hasEnglish = /[a-zA-Z]/.test(trimmedName)
  
  // 如果包含英文，不做处理
  if (hasEnglish) {
    return trimmedName
  }
  
  // 处理中文姓名
  const length = trimmedName.length
  
  if (length === 2) {
    // 2个字：最后一个字显示为星号
    return trimmedName.charAt(0) + '*'
  } else if (length === 3) {
    // 3个字：中间字显示为星号
    return trimmedName.charAt(0) + '*' + trimmedName.charAt(2)
  } else if (length > 3) {
    // 超过3个字：中间部分显示为星号（保留首尾）
    return trimmedName.charAt(0) + '*'.repeat(length - 2) + trimmedName.charAt(length - 1)
  }
  
  // 其他情况（1个字或特殊情况）不做处理
  return trimmedName
}

/**
 * 脱敏电话
 * @param {String} phone - 电话号码
 * @returns {String} 脱敏后的电话
 * 
 * 规则：
 * - 隐藏中间四位，改为星号（如：138****1234）
 * - 如果电话长度不足11位，只隐藏中间部分
 */
export function maskPhone(phone) {
  if (!phone || typeof phone !== 'string') {
    return phone || ''
  }
  
  const trimmedPhone = phone.trim()
  
  // 如果为空，直接返回
  if (!trimmedPhone) {
    return ''
  }
  
  // 移除所有非数字字符
  const digitsOnly = trimmedPhone.replace(/\D/g, '')
  
  // 如果数字长度不足，不做处理
  if (digitsOnly.length < 7) {
    return trimmedPhone
  }
  
  // 11位手机号：显示前3位和后4位，中间4位用星号
  if (digitsOnly.length === 11) {
    return digitsOnly.substring(0, 3) + '****' + digitsOnly.substring(7)
  }
  
  // 其他长度：显示前3位和后2位，中间用星号
  if (digitsOnly.length >= 7) {
    const front = digitsOnly.substring(0, 3)
    const back = digitsOnly.substring(digitsOnly.length - 2)
    const middle = '*'.repeat(digitsOnly.length - 5)
    return front + middle + back
  }
  
  // 长度不足7位，不做处理
  return trimmedPhone
}

/**
 * 脱敏姓名和电话（组合函数）
 * @param {String} name - 姓名
 * @param {String} phone - 电话
 * @returns {Object} 包含脱敏后的姓名和电话
 */
export function maskNameAndPhone(name, phone) {
  return {
    name: maskName(name),
    phone: maskPhone(phone)
  }
}
